import * as StringValidation from '../../libs/validation/stringRegex'
import * as Constants from '../../costants'

import { isValidPrivacy } from '../../components/privacy/BasicPrivacy'

import { authFetch } from '../../libs/cookie/Cookie'

import { basePageOneValidation, CONNECTION_ERROR } from '../../components/pagination/PageOneValidation'

import { isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'

import { UserType } from '../../libs/user/User'

import { ContractorType } from '../../components/people/contractor/Contractor'

export async function page1Validation (
    contractor: ContractorType,
    altriSinistri: boolean | undefined,
    polizzaAttiva: boolean | undefined,
    scadenzaPolizza: string | undefined,

    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    return basePageOneValidation (
        contractor,
        altriSinistri,
        polizzaAttiva,
        scadenzaPolizza,
        Constants.STEP_1_VALIDATION_URL,
        printErrorCallBack,
        manageExpiredSessionsCallBack
    )
}

export async function page2Validation (
    altriSinistri: boolean | undefined,
    polizzaAttiva: boolean | undefined,
    scadenzaPolizza: string | undefined,
    tipoVeicolo: string | undefined,
    targa: string | undefined,
    note: string | undefined,
    noMotorPrivacy: any,
    user: UserType | undefined,

    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    let error = undefined

    
    if (altriSinistri === undefined) {
        error = 'SINISTRI'
    }
    else if (polizzaAttiva === undefined) {
        error = 'POLIZZA'
    }
    else if (
        polizzaAttiva === true && 
        isNotValidScadenzaPolizza(scadenzaPolizza)
    ) {
        error = 'SCADENZA_POLIZZA'
    }
    else if (StringValidation.isEmpty( tipoVeicolo )) {
        error = 'TIPO_VEICOLO'
    }
    else if (
        !StringValidation.isValid(targa, StringValidation.PATTERN_TARGA_AUTO_NUOVA) &&
        !StringValidation.isValid(targa, StringValidation.PATTERN_TARGA_AUTO_VECCHIA)
    ) {
        error = 'TARGA'
    }
    else if (
        tipoVeicolo === 'altro' &&
        StringValidation.isEmpty( note )
    ) {
        error = 'NOTE'
    }
    else if (isValidPrivacy( noMotorPrivacy, user !== undefined)) {
        error = 'PRIVACY'
    }
    else {
        await authFetch (
            Constants.STEP_2_VALIDATION_URL,
            {
                method: "post",
                body: JSON.stringify({
                    sinistriPrecedenti: altriSinistri ?? false,
                    polizzaGiaAttiva: polizzaAttiva ?? false,
                    dataScadenza: (polizzaAttiva === true) 
                        ? (scadenzaPolizza ?? null)
                        : null,
                    Commercial_Vehicle_Usage_Type: tipoVeicolo ?? null,
                    Commercial_Vehicle_Plate: targa ?? null,
                    Commercial_Vehicle_Notes: note ?? null,
                    privacy: noMotorPrivacy ?? null,
                    isLoggedUser: (user !== undefined)
                })
            },
            manageExpiredSessionsCallBack,
        ).then ( jsonObj => {
            if (jsonObj.status > 200) {
                error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
            }
        }).catch( error => {
            error = CONNECTION_ERROR
        })
    }

    printErrorCallBack (error)

    return error
}

export function isNotValidTarga (targa: string | undefined) {
    return (
        !StringValidation.isValid(targa, StringValidation.PATTERN_TARGA_AUTO_NUOVA) === false &&
        !StringValidation.isValid(targa, StringValidation.PATTERN_TARGA_AUTO_VECCHIA) === false 
    )
}